import SetupMFA from './SetupMFA'

export default SetupMFA
